import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetOfferAndNotify } from 'helpers/resetOfferAndNotify';
import HeaderContainer from '../../containers/header';
import FooterContainer from '../../containers/footer';
import AuctionsSection from '../../containers/auctions';

const AuctionsPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    resetOfferAndNotify(dispatch);
  }, []);
  return (
    <>
      <HeaderContainer />
      <AuctionsSection />
      <FooterContainer />
    </>
  );
};

export default AuctionsPage;
